import BaseMutations from '@/store/base/mutations'

// const module = 'smsTemplates'

export default BaseMutations({
  //
})